var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C13 0.25 13.2188 0 13.5 0H17.5C17.75 0 18 0.25 18 0.5C18 0.78125 17.75 1 17.5 1H14V4.5C14 4.78125 13.75 5 13.5 5H9.5V9.5C9.5 9.78125 9.25 10 9 10H5V13.5C5 13.7812 4.75 14 4.5 14H0.5C0.21875 14 0 13.7812 0 13.5C0 13.25 0.21875 13 0.5 13H4V9.5C4 9.25 4.21875 9 4.5 9H8.5V4.5C8.5 4.25 8.71875 4 9 4H13V0.5Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/floor-icon.dad86da29751969dacc92d69c3ba8b19.svg";
export { ForwardRef as ReactComponent };